export default __webpack_public_path__ + "static/media/tempicon.ef9f6a96.png";